import { useRender } from '@base-ui/react/use-render'

import { cn } from '../../../../lib/utils.ts'

export function ItemMedia(props: ItemMedia.Props) {
  const { className, variant = 'default', ref, ...rest } = props
  return useRender({
    ref,
    defaultTagName: 'span',
    props: {
      'data-slot': 'item-media',
      'data-variant': variant,
      // The icon frame is decoration: the row's title carries the meaning. Callers can still override it.
      'aria-hidden': variant === 'icon' ? true : undefined,
      className: cn(
        // TODO: Revisit this foreground when co-branding theming is consolidated.
        // Its token mapping currently depends on partner-specific overrides.
        `
          flex shrink-0 items-center justify-center text-icon-base
          data-[variant=icon]:size-[32px] data-[variant=icon]:rounded-20 data-[variant=icon]:bg-gradient-brand-light
          data-[variant=icon]:text-icon-item-brand-light
          [&_svg:not([class*='size-'])]:size-6
          data-[variant=icon]:[&_svg:not([class*='size-'])]:size-[16px]
        `,
        className,
      ),
      ...rest,
    },
  })
}
export namespace ItemMedia {
  export type Props = React.ComponentProps<'span'> & {
    /** `icon` adds the icon frame and hides it from assistive technology; `default` has no frame. @default 'default' */
    variant?: 'icon' | 'default'
  }
}
